"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAYPAL_ACCOUNT_KEYS = exports.PAYPAL_ACCOUNT_COUNTRIES = exports.getPaypalCredentialsFromCountry = exports.getPaypalProviderKeyFromCountry = void 0;
const country_1 = require("../enums/country");
const getPaypalProviderKeyFromCountry = (country) => {
    switch (country) {
        case country_1.OrganizationCountry.Canada:
            return "paypalCad";
        case country_1.OrganizationCountry.UnitedStates:
            return "paypalUsa";
        case country_1.OrganizationCountry.GreatBritain:
            return "paypalUk";
        case country_1.OrganizationCountry.Australia:
            return "paypalAu";
        case country_1.OrganizationCountry.Ireland:
        case country_1.OrganizationCountry.Germany:
            return "paypalEu";
    }
    throw new Error("Country was not provided on the PayPal provider");
};
exports.getPaypalProviderKeyFromCountry = getPaypalProviderKeyFromCountry;
const getPaypalCredentialsFromCountry = (country, credentialsByCountry) => {
    if (!country) {
        return undefined;
    }
    switch (country) {
        case country_1.OrganizationCountry.Canada:
            return credentialsByCountry.paypalCad;
        case country_1.OrganizationCountry.UnitedStates:
            return credentialsByCountry.paypalUsa;
        case country_1.OrganizationCountry.GreatBritain:
            return credentialsByCountry.paypalUk;
        case country_1.OrganizationCountry.Australia:
            return credentialsByCountry.paypalAu;
        case country_1.OrganizationCountry.Ireland:
        case country_1.OrganizationCountry.Germany:
            return credentialsByCountry.paypalEu;
        default:
            return undefined;
    }
};
exports.getPaypalCredentialsFromCountry = getPaypalCredentialsFromCountry;
exports.PAYPAL_ACCOUNT_COUNTRIES = {
    paypalCad: country_1.OrganizationCountry.Canada,
    paypalUsa: country_1.OrganizationCountry.UnitedStates,
    paypalUk: country_1.OrganizationCountry.GreatBritain,
    paypalAu: country_1.OrganizationCountry.Australia,
    paypalEu: country_1.OrganizationCountry.Ireland,
};
exports.PAYPAL_ACCOUNT_KEYS = ["paypalCad", "paypalUsa", "paypalUk", "paypalAu", "paypalEu"];
